import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { fetchFavoriteBrands } from '@common/Brands/helpers/favoriteBrand';
import { getFormattedSizeFilters, getFiltersByType, getFormattedBrandFilters } from '@common/Filters/helpers';
import BrandsContext from '../context';
import { useBrandsGroup } from '../hooks/useBrandGroups';
import ActiveFilters from './ActiveFiltersM';
import { BrandsGroup } from './BrandsGroupMobile';
import { FiltersListGrouped } from './FiltersListGrouped';
import { FiltersListM as FiltersList } from './FiltersListM';
import { FiltersPrice } from './FiltersPrice';
import { FiltersTypes } from './FiltersTypes';
import '../styles/FiltersSorting.scss';

export function Filters({
    theme,
    currentFilterType,
    onFilterTypeUpdate,
    activeBrandId,
    search
}) {
    const { availableFilters, dropdownFilters, activeFilters } = useSelector(({ filters }) => filters);
    const { gender } = useSelector(({ listing }) => listing);
    const isSizeFilter = currentFilterType === 'size';
    const isBrandFilter = currentFilterType === 'brand';
    const isProductSeriesFilter = currentFilterType === 'tag-productseries';
    const isPriceRangeMinMax = currentFilterType === 'pricerange-minmax';
    const isCustomFilterType = isSizeFilter || isBrandFilter || isProductSeriesFilter || isPriceRangeMinMax;

    const { brandGroupsData, activeBrandIds } = useBrandsGroup();

    const setCurrentFilterType = (type) => {
        onFilterTypeUpdate(type);
    };

    const renderFiltersByType = (type) => {
        const filters = getFiltersByType({
            filterType: type,
            dropdownFilters,
            availableFilters,
            activeFilters
        });

        return (
            <FiltersListGrouped
                filters={filters}
                search={search}
                type={type}
            />
        );
    };

    const renderBrandFilter = () => {
        const filters = getFormattedBrandFilters({
            activeBrandId,
            dropdownFilters,
            availableFilters,
            activeFilters
        });
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        let customerFavoritesBrands = [];

        fetchFavoriteBrands((response) => {
            customerFavoritesBrands = response[gender].map(brand => brand.id);
        });

        return (
            <BrandsContext.Provider value={customerFavoritesBrands}>
                <FiltersListGrouped
                    filters={filters}
                    search={search}
                    theme={theme}
                    type="brand"
                >
                    <BrandsGroup
                        activeBrandIds={activeBrandIds}
                        brandGroupsData={brandGroupsData}
                        brands={filters}
                        theme={theme}
                    />
                </FiltersListGrouped>
            </BrandsContext.Provider>
        );
    };

    const renderSizeFilter = () => {
        const filters = getFormattedSizeFilters({
            dropdownFilters, availableFilters, activeFilters
        });
        return (
            <FiltersListGrouped
                filters={filters}
                theme="mod8"
                type="size"
            />
        );
    };

    return (
        <div className={classNames('filters-sorting', { [`filters-sorting--${theme}`]: theme })}>
            {!currentFilterType
                && (
                    <>
                        <FiltersTypes setCurrentFilterType={setCurrentFilterType} />
                        <ActiveFilters />
                    </>
                )}
            {currentFilterType
                && (
                    <>
                        {!isCustomFilterType
                            && <FiltersList filterType={currentFilterType} />}
                        {isSizeFilter && renderSizeFilter()}
                        {isBrandFilter && renderBrandFilter()}
                        {isProductSeriesFilter && renderFiltersByType('tag-productseries')}
                        {isPriceRangeMinMax && <FiltersPrice />}
                    </>
                )}
        </div>
    );
}
